/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ region: NonNullable<unknown>, level: NonNullable<unknown> }} Profile_Pain_ChipInputs */

const en_us2_profile_pain_chip = /** @type {(inputs: Profile_Pain_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region}: ${i?.level} pain`)
};

const pt_br2_profile_pain_chip = /** @type {(inputs: Profile_Pain_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region}: dor ${i?.level}`)
};

const es_419_profile_pain_chip = /** @type {(inputs: Profile_Pain_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region}: dolor ${i?.level}`)
};

const pt_pt2_profile_pain_chip = /** @type {(inputs: Profile_Pain_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region}: dor ${i?.level}`)
};

const fr_fr2_profile_pain_chip = /** @type {(inputs: Profile_Pain_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region} : douleur ${i?.level}`)
};

const de_de2_profile_pain_chip = /** @type {(inputs: Profile_Pain_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region}: Schmerz ${i?.level}`)
};

const it_it2_profile_pain_chip = /** @type {(inputs: Profile_Pain_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region}: dolore ${i?.level}`)
};

/**
* | output |
* | --- |
* | "{region}: {level} pain" |
*
* @param {Profile_Pain_ChipInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_pain_chip = /** @type {((inputs: Profile_Pain_ChipInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Pain_ChipInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_pain_chip(inputs)
	if (locale === "es-419") return es_419_profile_pain_chip(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_pain_chip(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_pain_chip(inputs)
	if (locale === "de-DE") return de_de2_profile_pain_chip(inputs)
	if (locale === "it-IT") return it_it2_profile_pain_chip(inputs)
	return en_us2_profile_pain_chip(inputs)
});
export { profile_pain_chip as "profile.pain_chip" }